import search from "./search/zh_cn.yml";
import hotel from "./hotel/zh_cn.yml";
import hotelWaitingList from "./hotelWaitingList/zh_cn.yml";
import activity from "./activity/zh_cn.yml";
import camp from "./camp/zh_cn.yml";
import booking from "./booking/zh_cn.yml";
import bookingActivity from "./bookingActivity/zh_cn.yml";
import bookingCamp from "./bookingCamp/zh_cn.yml";
import checkIn from "./checkIn/zh_cn.yml";
import user from "./user/zh_cn.yml";
import common from "./common/zh_cn.yml";
import notification from "./notification/zh_cn.yml";

export const componentZhCn: any = {
  search: search["zh_cn"]["componentSearch"],
  hotel: hotel["zh_cn"]["componentHotel"],
  hotelWaitingList: hotelWaitingList["zh_cn"]["componentHotelWaitingList"],
  activity: activity["zh_cn"]["componentActivity"],
  camp: camp["zh_cn"]["componentCamp"],
  booking: booking["zh_cn"]["componentBooking"],
  bookingActivity: bookingActivity["zh_cn"]["componentBookingActivity"],
  bookingCamp: bookingCamp["zh_cn"]["componentBookingCamp"],
  checkIn: checkIn["zh_cn"]["componentCheckIn"],
  user: user["zh_cn"]["componentUser"],
  common: common["zh_cn"]["componentCommon"],
  notification: notification["zh_cn"]["componentNotification"],
};
